import { Component } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { GridModule } from '@progress/kendo-angular-grid';
import { AcdService } from 'src/app/services/dashboard.service';
import { EmdmIcons } from 'src/app/services/appicons.service';
// import { MultiCheckFilterComponent } from '../dashboard/dashboardhome/multicheckbox-filter/multicheckbox-filter.component';
import {
    filterBy,
    CompositeFilterDescriptor,
    distinct,
    SortDescriptor,
} from '@progress/kendo-data-query';
import { DataConsoleService } from './dataconsole.service';
@Component({
    selector: 'app-dataconsole',
    templateUrl: './dataconsole.component.html',
    styleUrl: './dataconsole.component.scss'
})
export class DataconsoleComponent {
    public gridData: any = [];
    // public filter!: CompositeFilterDescriptor;

    wholegridData: any = this.gridData;
    faCompleted = this.iconPacks.FacircleCheck;
    faError = this.iconPacks.FaTimesClock;
    faInprogres = this.iconPacks.FaClock;
    public statusCount = {
        Completed: 0,
        InError: 0,
        InProgress: 0
    }
    sort: SortDescriptor[] = [];

    constructor(private dataConsoleService: DataConsoleService, private iconPacks: EmdmIcons) {

    }

    ngOnInit() {
        this.gridRefresh();
    }

    gridRefresh() {
        this.dataConsoleService.getGridData().subscribe((data : any)=>{
            
                this.gridData = data.dataConsoleDetails.map((data:any)=>{
                    data.lastUpdated = new Date(data.lastUpdated);
                    return data;
                });
                this.statusCount.Completed = data.summary.sucessfulTables;
                this.statusCount.InProgress = data.summary.inprogressTables;
                this.statusCount.InError = data.summary.failedTables;
                this.sort =  [{dir: "desc", field: "lastUpdated"}];
                
            
          });
    }


    onRefreshClick() {
        window.location.reload();
    }

    public distinctPrimitive(fieldName: string): unknown[] {
        return distinct(this.wholegridData, fieldName).map(
            (item: any) => item[fieldName]
        );
    }
}
